/** Passos do assistente — alinhado ao fluxo de criação de imóvel */

export type EditPropertyStepId =
  | "map"
  | "description"
  | "publication"
  | "characteristic"
  | "photos"
  | "history";

export const EDIT_STEPS: { id: EditPropertyStepId; label: string }[] = [
  { id: "map", label: "ENDEREÇO" },
  { id: "description", label: "IMÓVEL" },
  { id: "publication", label: "PUBLICAÇÃO" },
  { id: "characteristic", label: "CARACTERÍSTICAS" },
  { id: "photos", label: "FOTOS" },
  { id: "history", label: "HISTÓRICO" },
];

export const ZAP_PUBLICATION_OPTIONS = {
  STANDARD: "STANDARD",
  PREMIUM: "PREMIUM",
  TRIPLE: "TRIPLE",
  SUPER_PREMIUM: "SUPER_PREMIUM",
  PREMIERE_1: "PREMIERE_1",
} as const;

export const FLOOR_TYPE_OPTIONS = {
  LOW: "Baixo",
  MEDIUM: "Intermediário",
  HIGH: "Alto",
} as const;

/** Voltar / Próximo — #6EA5FF */
export const editStepNavBtn =
  "inline-flex shrink-0 items-center justify-center gap-2 border-0 bg-[#6EA5FF] px-4 py-3 text-sm font-bold text-white transition hover:bg-[#5c94ed] disabled:opacity-70 [&>p]:m-0 [&>p]:text-white";

/** Salvar — #00BF33 */
export const editStepSaveBtn =
  "inline-flex shrink-0 items-center justify-center border-0 bg-[#00BF33] px-6 py-3 text-sm font-bold text-white transition hover:bg-[#00a62c] disabled:cursor-not-allowed disabled:opacity-70 [&>p]:m-0 [&>p]:text-white";
